import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  get_vendor_fulfillment,
  advance_fulfillment,
  get_owner_fulfillment,
} from './api';
import type { AdvanceFulfillmentInput } from './types';

const vendor_key = (booking_id: string) => ['vendor-cremation', booking_id] as const;
const owner_key = (booking_id: string) => ['owner-cremation', booking_id] as const;

// ---- Vendor (provider) ----
export function use_vendor_fulfillment(booking_id: string, enabled = true) {
  return useQuery({
    queryKey: vendor_key(booking_id),
    queryFn: () => get_vendor_fulfillment(booking_id),
    enabled,
  });
}

export function use_advance_fulfillment(booking_id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: AdvanceFulfillmentInput) => advance_fulfillment(booking_id, input),
    onSuccess: (data) => {
      qc.setQueryData(vendor_key(booking_id), data);
      qc.invalidateQueries({ queryKey: ['vendor-bookings'] });
    },
  });
}

// ---- Owner ----
export function use_owner_fulfillment(booking_id: string, enabled = true) {
  return useQuery({
    queryKey: owner_key(booking_id),
    queryFn: () => get_owner_fulfillment(booking_id),
    enabled,
  });
}
